var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicsvgDownload8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 4758 c-1527 -138 -2445 -1826 -1745 -3208 818 -1612 3151 -1597 3953 25 772 1560 -463 3341 -2208 3183z m685 -318 c267 -64 567 -208 745 -358 l70 -59 -1360 -1361 c-748 -749 -1369 -1359 -1380 -1355 -86 28 -332 495 -404 769 -368 1400 915 2703 2329 2364z m1119 -752 c914 -1281 0 -3055 -1574 -3055 -458 0 -1051 210 -1241 438 -27 32 2666 2755 2711 2742 11 -3 58 -59 104 -125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload8);
export default __webpack_public_path__ + "static/media/picsvg_download(8).0a1e7ac4b31277cec075b3fb47aa620c.svg";
export { ForwardRef as ReactComponent };